import { Box, Button, Grid2, Typography } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CustomIconButton } from '../../shared/utils/IconButton';
import { Form_Padding } from '../../shared/constants';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField';
import { VerticalDivider } from '../../shared/utils/CustomDivider';
import useAuthStore from '../../store/useAuthStore';
import { useApartmentListForCourse } from '../../assets/api/useAdminApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import api from '../../assets/nodeApi/axiosInstance';
import { DropzoneUploadFormField } from '../../shared/components/formfields/DropzoneUploadFormField';

const StudentDetailForm = ({ onClose }) => {

    const { data: userDetail } = useGetUserDetail()
    const { token } = useAuthStore();
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptionsStu = (apartmentList?.data || [])
        .filter(item =>
            ["Approved By Manager", "Accepted By Apartment", "Created"].includes(item?.terms_status)
        )
        .map(item => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        }));

    const validationSchema = yup.object().shape({
        // lastname: yup.string().required("First Name is required"),
        // lastname: yup.string(),
        // dateofbirth: yup.date().required("Date of Birth is required"),
        // gender: yup.string().required("Gender is required"),
        // country_name: yup.string().required("Country is required"),
        // city: yup.string().required("City is required"),
        // apartment_name: yup.string().required("Apartment Name is required"),
        // address: yup.string().required("Address is required"),
        // state: yup.string().required("State is required"),
        // // district: yup.string().required("District is required"),
        // zip: yup.string().required("Pincode is required"),
        // child_school: yup.string().required("School Name is required"),
        // firstname: yup.string().required("Parents’s Name is required"),
        // email: yup.string().required("Email is required"),
        // mobile: yup.string().required("Mobile No is required"),
        // fatherlastname: yup.string().required("Father’s Last Name is required"),
        // fathermobileno: yup.string().required("Father’s Mobile Number is required"),
        // fathermobileno: yup.string().test("is-phone", "Phone number is not valid", function (value) {
        //     if (!value) return false;
        //     return isValidPhoneNumber(value);
        // }),
        // fathermailid: yup.string().email("Invalid email").required("Father’s Mail ID is required"),
        // mothername: yup.string().required("Mother’s Name is required"),
        // motherlastname: yup.string().required("Mother’s Last Name is required"),
        // mothermobileno: yup.string().required("Mother’s Mobile Number is required"),
        // mothermailid: yup.string().email("Invalid email").required("Mother’s Mail ID is required"),
    });


    const initialValues = {
        lastname: userDetail?.data?.lastname || "",
        // lastname: "",
        // dateofbirth: "",
        // gender: "",
        city: userDetail?.data?.city || "",
        apartment_name: userDetail?.data?.apartment_name || "",
        address: userDetail?.data?.address || "",
        country_name: userDetail?.data?.country_name || "",
        state: userDetail?.data?.state || "",
        // district: "",
        zip: userDetail?.data?.zip || "",
        age: userDetail?.data?.age || "",
        child_grade: userDetail?.data?.child_grade || "",
        child_school: userDetail?.data?.child_school || "",
        firstname: userDetail?.data?.firstname || "",
        email: userDetail?.data?.email || "",
        mobile: userDetail?.data?.mobile || "",
        profile_image: userDetail?.data?.profile_image || ""
        // fatherlastname: "",
        // fathermobileno: user?.mobile || "",
        // fathermailid: user?.email || "",
        // mothername: "",
        // motherlastname: "",
        // mothermobileno: "",
        // mothermailid: "",
    };



    const updateMutation = useMutation({
        mutationFn: (formData) => api.post("update-profile", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            },
        }),
    });

    const handleSubmit = (values) => {
        console.log(values);
        const formData = new FormData();
        if (values.profile_image && typeof values.profile_image !== "string") {
            formData.append('profile_image', values.profile_image);
        }
        formData.append('lastname', values?.lastname);

        formData.append('country_name', values?.country_name);
        formData.append('state', values?.state);
        formData.append('city', values?.city);

        formData.append('zip', values?.zip);
        formData.append('apartment_name', values?.apartment_name);
        formData.append('address', values?.address);

        formData.append('email', values?.email);
        formData.append('mobile', values?.mobile);
        formData.append('firstname', values?.firstname);

        formData.append('child_school', values?.child_school);
        formData.append('child_grade', values?.child_grade);
        formData.append('age', values?.age);

        updateMutation.mutate(formData, {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['user/details'] });
                showToaster('Profile Update Successfullly', '', 'success')
            },
            onError: (error) => {
                showToaster(error?.data?.error || 'Something went wrong', '', 'error')
            }

        });

    }

    const data = [
        // { name: "Student ID", value: "Apt2345678" },
        { name: "Apartment", value: userDetail?.data?.apartment_name },
        { name: "Number", value: userDetail?.data?.mobile },
        // { name: "Location", value: "J.P Nagar" },
    ];


    return (
        <>
            <Box >
                <Box sx={{ p: Form_Padding, bgcolor: "blue.main", position: "relative", minBlockSize: "80px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box>
                            <Typography variant='h5' color='text.secondary' textTransform={"capitalize"}>{`${userDetail?.data?.lastname}`}</Typography>
                            {data.map((item, index) => (
                                <Typography variant='h5' color='text.secondary' key={index} my={0.5}>
                                    {item.name} : {item.value}
                                </Typography>
                            ))}
                        </Box>

                        <CustomIconButton icon={<KeyboardBackspaceIcon style={{ color: "#fff" }} fontSize='26px' />} onClick={() => { onClose() }} />
                    </Box>
                    {/* <Box
                        sx={{
                            position: "absolute",
                            bottom: "-60px",
                            left: "50%",
                            transform: "translateX(-50%)",
                        }}
                    >
                        <Avatar
                            src={Constants.customImages.StudentPic}
                            alt="Profile"
                            sx={{
                                width: { lg: "100px", sm: "100px", xs: "70px" },
                                height: { lg: "104px", sm: "100px", xs: "70px" },
                                border: "8px solid #fff",
                            }}
                        />
                    </Box> */}

                </Box>

                <Box sx={{ p: Form_Padding, mt: "80px" }}>
                    <Formik initialValues={initialValues} enableReinitialize={true} validationSchema={validationSchema} onSubmit={handleSubmit}>
                        {() => (
                            <Form>

                                <Grid2 container spacing={"20px"} sx={{ display: 'flex', justifyContent: "space-between" }}>



                                    <Grid2 container size={{ lg: 5.5, xs: 12 }}>
                                        <Grid2 children size={{ xs: 12 }}>
                                            <Field
                                                name="profile_image"
                                                component={DropzoneUploadFormField}
                                                label="Student Photo"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="lastname"
                                                component={TextFormField}
                                                label="First Name"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="lastname"
                                                component={TextFormField}
                                                label="Last Name"
                                                isRequired={false}
                                            />
                                        </Grid2> */}

                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="dateofbirth"
                                                component={DateFormField}
                                                label="Date of Birth"
                                                isRequired={true}
                                                maxDate={moment(getCurrentDate(), "YYYY-MM-DD")}
                                            />
                                        </Grid2> */}
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="gender"
                                                component={AutoCompleteField}
                                                options={genderOptions}
                                                label="Gender"
                                                isRequired={false}
                                            />
                                        </Grid2> */}




                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="zip"
                                                component={TextFormField}
                                                label="Pincode"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <LocationSelectorField
                                            countryField="country_name"
                                            stateField="state"
                                            cityField="city"
                                            isStoredId={false}
                                            Input_Width={{ sm: 6, xs: 12 }}
                                            isProfile={true}
                                            zipField={"zip"}
                                            userDetail={userDetail?.data}
                                            passedCityId={userDetail?.data?.city_id}
                                            passedStateId={userDetail?.data?.state_id}
                                            passedCountryId={userDetail?.data?.country_id}
                                            isPincode={false}
                                        />
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="apartment_name"
                                                component={AutoCompleteField}
                                                options={ApartmentOptionsStu}
                                                isLoading={isLoadingApartmentList}
                                                label="Apartment Name"
                                                isRequired={true}
                                            />
                                        </Grid2>

                                        <Grid2 children size={12}>
                                            <Field
                                                name="address"
                                                component={TextFormField}
                                                label="Address"
                                                isRequired={true}
                                            />
                                        </Grid2>



                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="district"
                                                component={AutoCompleteField}
                                                options={cityOptions}
                                                label="district"
                                                isRequired={true}
                                            />
                                        </Grid2> */}

                                    </Grid2>
                                    <VerticalDivider />
                                    <Grid2 container size={{ lg: 5.5, xs: 12 }}>


                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="child_school"
                                                component={TextFormField}
                                                label="School Name"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="age"
                                                component={TextFormField}
                                                label="Age "
                                                isRequired={true}
                                                type="number"
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="child_grade"
                                                component={TextFormField}
                                                label="Child Grade"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="firstname"
                                                component={TextFormField}
                                                label="Parent’s Name "
                                                isRequired={true}
                                                disabled={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="email"
                                                component={TextFormField}
                                                label="Email"
                                                isRequired={true}
                                                disabled
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="mobile"
                                                component={PhoneInputFormField}
                                                label="mobile"
                                                isRequired={true}
                                                disabled={true}
                                            />
                                        </Grid2>
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="fatherlastname"
                                                component={TextFormField}
                                                label="Father’s Last Name "
                                                isRequired={true}
                                            />
                                        </Grid2> */}
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="fathermobileno"
                                                component={PhoneInputFormField}
                                                label="Father’s Mobile Number "
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="fathermailid"
                                                component={TextFormField}
                                                label="Fathers Mail-Id "
                                                isRequired={true}
                                            />
                                        </Grid2> */}

                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="mothername"
                                                component={TextFormField}
                                                label="Mother’s Name"
                                                isRequired={true}
                                            />
                                        </Grid2> */}
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="motherlastname"
                                                component={TextFormField}
                                                label="Mother’s Last Name"
                                                isRequired={true}
                                            />
                                        </Grid2> */}
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="mothermobileno "
                                                component={TextFormField}
                                                label="Mother’s Mobile Number"
                                                isRequired={true}
                                            />
                                        </Grid2> */}
                                        {/* <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Field
                                                name="mothermailid"
                                                component={TextFormField}
                                                label="Mother’s Mail-Id "
                                                isRequired={true}
                                            />
                                        </Grid2> */}

                                        <Grid2 children size={{ sm: 6, xs: 12 }} />
                                        <Grid2 children size={{ sm: 6, xs: 12 }}>
                                            <Button variant="contained" fullWidth type="submit">save </Button>
                                        </Grid2>


                                    </Grid2>

                                </Grid2>

                            </Form>
                        )}
                    </Formik>
                </Box>
            </Box>
        </>
    )
}

export default StudentDetailForm